// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9b40f9f2","952":"2ae15a26"}[chunkId] + ".chunk.js";
};